<template>
  <div class="admin">
    <v-layout row wrap fill-height class="team admin__route">
      <v-flex xs12 md3>
        <v-card>
          <v-list class="py-0" expand v-if="$vuetify.breakpoint.mdAndUp">
            <category-item
              :parentRoute="parentRoute"
              v-for="category in categories"
              :key="category.id"
              :category="category"
            ></category-item>
          </v-list>

          <v-list v-else class="py-0" expand>
            <v-list-group :v-model="listOpen">
              <v-list-tile slot="activator" class="decision-tree__category">
                <v-list-tile-content>
                  <v-list-tile-title>Choose a Category</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <category-item
                :parentRoute="parentRoute"
                v-for="category in categories"
                :key="category.id"
                :category="category"
              ></category-item>
            </v-list-group>
          </v-list>
        </v-card>
      </v-flex>

      <v-flex xs12 md9>
        <router-view :key="$route.fullPath"></router-view>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import CategoryItem from "./document-center/CategoryItem";

export default {
  name: "Categories",

  data() {
    return {
      listOpen: false,
      categories: [],
      parentRoute: "/admin/categories"
    };
  },

  components: {
    CategoryItem
  },

  computed: {
    ...mapGetters(["user"]),

    breadCrumbs() {
      return [];
    }
  },

  methods: {
    ...mapActions("document_center", ["getCategories", "getPermissionGroups"]),
    ...mapMutations("document_center", ["setCategories", "setPermissionGroups"])
  },

  created() {
    this.getCategories({ admin: true, topLevel: true }).then(({ data }) => {
      this.$set(this, "categories", data);
    });

    this.getPermissionGroups().then(({ data }) => {
      this.setPermissionGroups(data);
    });
  }
};
</script>
